import React from 'react'
// containers
import RiskTemplateContainer from 'containers/Risks/RiskTemplate/Edit'

const RiskTemplatePage: React.FC = () => <RiskTemplateContainer />

export default RiskTemplatePage
